<template>
	<div class="home-wrapper">
		<section id="hero" class="d-flex align-items-center">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
						<h1>Free SSL Redirect for Your Domain</h1>
						<h2>Redirect your domain over HTTPS without having to pay for an SSL certificate</h2>
						<div class="d-flex">
							<router-link :to="{ name: 'register' }" class="btn-get-started scrollto">Get Started</router-link>
							<router-link :to="{ name: 'login' }" class="btn-watch-video">Login</router-link>
						</div>
						<p class="lead font-italic mt-4">No credit card required!</p>
					</div>
					<div class="col-lg-6 order-1 order-lg-2 hero-img">
						<img src="/images/test.png" class="img-fluid animated" alt="">
					</div>
				</div>
			</div>
		</section>
		<section id="about" class="about section-bg">
			<div class="container">
				<div class="row">
					<div class="col-lg-6">
						<img src="/images/connection-private.png" class="img-fluid" alt="">
					</div>
					<div class="col-lg-6 pt-4 pt-lg-0 content">
						<h3>Avoid insecure connection warnings when redirecting your domain</h3>
						<p class="font-italic">Our service is perfect for old or extra domains that simply need to redirect to another domain.</p>
						<p>How does it work?</p>
						<ol>
							<li><i class="icofont-check-circled"></i> Update your DNS to point your domain to our servers</li>
							<li><i class="icofont-check-circled"></i> We obtain and install a certificate for your domain</li>
							<li><i class="icofont-check-circled"></i> Choose where you'd like to redirect your domain</li>
						</ol>
					</div>
				</div>
			</div>
		</section>
		<section id="features" class="faq">
			<div class="container">
				<div class="section-title">
      				<span>Features</span>
      				<h2>Features</h2>
      				<p>Everything you need for one low price</p>
      			</div>
      			<div class="row">
      				<div class="col-sm-6 mb-2">
      					<div class="card h-100">
      						<div class="card-body h-100">
      							<h4 class="font-weight-bold"><i class="fa fa-lock"></i> Free SSL Certificate</h4>
      							<p>We automatically obtain and install an SSL certificate for you.</p>
      						</div>
      					</div>
      				</div>
      				<div class="col-sm-6 mb-2">
      					<div class="card h-100">
      						<div class="card-body h-100">
      							<h4 class="font-weight-bold"><i class="fa fa-share"></i> Advanced Redirects<span class="small text-muted">*</span></h4>
      							<p>Fine-tune your redirects by specifying the exact source and destination URLs.</p>
      						</div>
      					</div>
      				</div>
      				<div class="col-sm-6 mb-2">
      					<div class="card h-100">
      						<div class="card-body h-100">
      							<h4 class="font-weight-bold"><i class="fa fa-chart-simple"></i> Detailed Analytics<span class="small text-muted">*</span></h4>
      							<p>See how many hits your domains are getting and where your traffic is coming from.</p>
      						</div>
      					</div>
      				</div>
      				<div class="col-sm-6 mb-2">
      					<div class="card h-100">
      						<div class="card-body h-100">
      							<h4 class="font-weight-bold"><i class="fa fa-headset"></i> Excellent Support</h4>
      							<p>Have an issue, question or feature request? We're there for you day or night.</p>
      						</div>
      					</div>
      				</div>
      				<div class="col-sm-12 mt-2">
      					<p class="small text-muted">* requires paid plan</p>
      				</div>
      			</div>
			</div>
		</section>
		<section class="pricing section-bg" id="pricing">
      		<div class="container">
      			<div class="section-title">
      				<span>Pricing</span>
      				<h2>Pricing</h2>
      				<p>Save <b>hundreds of dollars per year</b> on SSL certificates</p>
      			</div>
      			<div class="row">
      				<div class="col-lg-4">
						<div class="card mb-5 mb-lg-0">
							<div class="card-body">
								<h5 class="card-title text-muted text-uppercase text-center">Free</h5>
								<h6 class="card-price text-center">$0<span class="period">/month</span></h6>
								<hr>
								<ul class="fa-ul">
						  			<li><span class="fa-li"><i class="fas fa-check"></i></span>Up to <b>(1)</b> Domain</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Redirect Domain over HTTPS</li>
									<li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Advanced URL Redirects</li>
									<li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Dedicated Phone Support</li>
									<li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Redirect Counter</li>
									<li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Hands-off DNS Setup Provided</li>
								</ul>
								<router-link :to="{ name: 'register' }" class="btn btn-block btn-primary text-uppercase">Get Started</router-link>
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="card mb-5 mb-lg-0 featured">
							<div class="card-body">
								<h5 class="card-title text-muted text-uppercase text-center">Plus</h5>
								<h6 class="card-price text-center">$5<span class="period">/month</span></h6>
								<hr>
								<ul class="fa-ul">
						  			<li><span class="fa-li"><i class="fas fa-check"></i></span>Up to <b>(10)</b> Domains</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Redirect Domains over HTTPS</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Advanced URL Redirects</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Dedicated Phone Support</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Redirect Counter</li>
									<li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Hands-off DNS Setup Provided</li>
								</ul>
								<router-link :to="{ name: 'register' }" class="btn btn-block btn-primary text-uppercase">Get Started</router-link>
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="card mb-5 mb-lg-0">
							<div class="card-body">
								<h5 class="card-title text-muted text-uppercase text-center">Pro</h5>
								<h6 class="card-price text-center">$15<span class="period">/month</span></h6>
								<hr>
								<ul class="fa-ul">
						  			<li><span class="fa-li"><i class="fas fa-check"></i></span>Up to <b>(25)</b> Domains</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Redirect Domains over HTTPS</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Advanced URL Redirects</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Dedicated Phone Support</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Advanced Analytics</li>
									<li><span class="fa-li"><i class="fas fa-check"></i></span>Hands-off DNS Setup Provided</li>
								</ul>
								<router-link :to="{ name: 'register' }" class="btn btn-block btn-primary text-uppercase">Get Started</router-link>
							</div>
						</div>
					</div>
					<div class="col-12 mt-4 text-center">
						<p class="small text-muted">Need more domains? No problem! <a href="#contact">Contact us for a custom quote</a></p>
					</div>
				</div>
      		</div>
      	</section>
      	<section id="faq" class="faq">
			<div class="container">
				<div class="section-title">
      				<span>FAQ</span>
      				<h2>FAQ</h2>
      				<p>You've got questions, we've got answers</p>
      			</div>
      			<div class="accordion" id="faqExample">
	                <div class="card">
	                    <div class="card-header p-2">
	                        <h5 class="mb-0"><button @click="showCard = 1" class="btn btn-link w-100 text-left" type="button">How does it work?</button>
	                          </h5>
	                    </div>
	                    <transition name="slide-down">
		                    <div class="collapse show" v-if="showCard == 1">
		                        <div class="card-body">
		                        	<p class="mb-0">Simply point your domain to our servers and tell us where to redirect it and we handle the rest! We obtain a certificate for your domain and automatically configure and install it. We also handle the renewal process so there is nothing else to worry about!</p>
		                        </div>
		                    </div>
		                </transition>
	                </div>
	                <div class="card">
	                    <div class="card-header p-2">
	                        <h5 class="mb-0"><button @click="showCard = 4" class="btn btn-link w-100 text-left" type="button">What if I don't know how to update my DNS?</button>
	                          </h5>
	                    </div>
	                    <transition name="slide-down">
		                    <div class="collapse show" v-if="showCard == 4">
		                        <div class="card-body">
		                        	<p class="mb-0">We understand DNS can be confusing. That's why we offer a Pro plan that includes hands-off DNS setup or, for a small fee, we can help update your domain's DNS records to point to our server. Just <a href="#contact">contact us</a> for assistance!</p>
		                        </div>
		                    </div>
						</transition>
	                </div>
	                <div class="card">
	                    <div class="card-header p-2">
	                        <h5 class="mb-0"><button @click="showCard = 2" class="btn btn-link w-100 text-left" type="button">How do you obtain your certificates?</button>
	                      </h5>
	                    </div>
	                    <transition name="slide-down">
		                    <div class="collapse show" v-if="showCard == 2">
		                        <div class="card-body">
		                            <p class="mb-0">We utilize the widely popular service, <a target="_blank" href="https://letsencrypt.org">LetsEncrypt</a> to obtain a secure certificate for your domain.</p>
		                        </div>
		                    </div>
		                </transition>
	                </div>
	                <div class="card">
	                    <div class="card-header p-2">
	                        <h5 class="mb-0"><button @click="showCard = 3" class="btn btn-link w-100 text-left" type="button">Why do I need to use HTTPS if all I'm doing is redirecting?</button></h5>
	                    </div>
	                    <transition name="slide-down">
		                    <div class="collapse show" v-if="showCard == 3">
		                        <div class="card-body">
		                            <p class="mb-0">You might not need to! Our service is great if you have an old domain that may be linked other places on the Internet via HTTPS or if you want to avoid customers accidentally typing in the secure version of your domain. Browsers often tend to try and connect over HTTPS first as well.</p>
		                        </div>
		                    </div>
		                </transition>
	                </div>
	                <div class="card">
	                    <div class="card-header p-2">
	                        <h5 class="mb-0"><button @click="showCard = 5" class="btn btn-link w-100 text-left" type="button">Do subdomains count as a separate domain?</button></h5>
	                    </div>
	                    <transition name="slide-down">
		                    <div class="collapse show" v-if="showCard == 5">
		                        <div class="card-body">
		                            <p class="mb-0">Yes, with the exception of <em>(www)</em>, each subdomain will count towards your domain limit. The <em>(www)</em> subdomain is included at no additional charge.</p>
		                        </div>
		                    </div>
		                </transition>
	                </div>
	            </div>
			</div>
		</section>
      	<section id="contact" class="contact section-bg">
      		<div class="container">
      			<div class="section-title">
      				<span>Contact</span>
      				<h2>Contact</h2>
      				<p>Questions, comments, concerns? Drop us a line, we're here to help!</p>
      			</div>
      			<div class="row">
					<div class="col-sm-8 offset-sm-2 mt-5 mt-lg-0">
						<ContactForm />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
  		name: 'Home',
  		data() {
  			return {
  				showCard: 1
  			}
  		},
  		components: {
  			ContactForm: () => import('@home/components/ContactForm'),
  		}
  	};
</script>